<template>
	<div class="main_iblogin_sec">
		<loader v-if="pageLoader"></loader>
		<div class="container">
			<div class="blockmaze_logosec">
				<img src="../../../../static/ibcoinexx/img/backend/product_images/product_logo.png" alt="" />
			</div>
		</div>
		<section class="sign_up_mainsec">
			<div class="container">
				<div class="row">
					<div class="col-sm-12">
							<div class="outer_left_abtsec">
								<div class="abt_company_contsec">
									<h1>Log In</h1>
									<div class="login--status--outer" v-if="response_msg != ''">
										<div class="login--response" :class="msg_type">{{response_msg}}</div>
									</div>
									<div class="affilate_signup_fieldsec">
										<div class="form-group login_field_sec">
											<div class="col-sm-12 padding-right padding-left">
												<input type="email" name="email" v-model="email" class="affilate_txtin" placeholder="Email" id="email"  v-validate="'required|email'" />
												<label v-show="submitted && errors.has('email')" class="error">{{ errors.first('email') }}</label>
											</div>
											<div class="col-sm-12 padding-right padding-left">
												<input :type="show_pass" name="password" v-model="password" class="affilate_txtin" placeholder="Password"  maxlength="20" id="password" v-validate="'required|max:10'"/>
												<label v-show="submitted && errors.has('password')" class="error">{{ errors.first('password') }}</label>
												<p class="password-eye"><password-icon v-model="show_pass"></password-icon></p>
											</div>
											<!--<div class="remember_login_sec col-xs-12">
												<a href="forgotPassword.html" class="pull-right"><i class="fa fa-lock"></i> Forgot Password</a>
											</div>-->
											<div class="col-sm-12 padding-right padding-left d-flex-align-between">
												<div><button class="affilate_subin" v-on:click="login()"><i class="fa fa-sign-in" type="submit"></i>LOGIN </button></div>
												<div class="login_forgot_sec--s">
														<router-link to="/forgotPassword">Forgot Password?</router-link>
												</div>
											</div>
											<div class="register_linksec registerOption">
												<span>Don’t have an account? <a href="/register" class="d-inline-block">Register?</a></span>
											</div>
										</div>
									</div>
								</div>
							</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
    import * as types from '@/types'
    import { mapActions } from 'vuex' 
    export default {
        name: 'LOGIN',
		mixins: [fxViewMixins],
        data(){     
            return {
				msg_type : '',
                response_msg : '',          
                pageLoader : false,
                email:"",
				password:"",
				submitted: false,
				show_pass: 'password'
            }
        },
        methods:{
			...mapActions({
                _runLogin: types.RUN_USER_LOGIN
            }),
			login(){
				const _that = this
				this.submitted = true;
				this.$validator.validate().then(valid => {
					if (valid){
						let inputJson={
							'globalParams':{
								"email": _that.email,
								"password": _that.password,
							},
							'localParams' : {
								'parameter' : _that
							}
						}
						_that._runLogin(inputJson)
					}
				});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/user/login.vue